<div class="floor-plan-container">
  <div class="floor-plan-body">
    <div class="floor-plan-sidebar">
      <app-zone-selector 
        [zones]="zones"
        [selectedZoneId]="selectedZoneId"
        [canCreate]="canCreateMesas"
        [canEdit]="canEditMesas"
        (zoneSelected)="onZoneSelected($event)"
        (createZone)="openNewZoneForm()"
        (deleteZone)="confirmDeleteZone($event)">
      </app-zone-selector>
    </div>

    <app-table-grid
      [tables]="getTablesByZone()"
      [selectedTables]="selectedTables"
      [selectedZoneId]="selectedZoneId"
      [canCreate]="canCreateMesas"
      [canEdit]="canEditMesas"
      (tableClick)="onTableClick($event[0], $event[1])"
      (tableDoubleClick)="onTableDoubleClick($event)"
      (tableMoved)="onTableMoved($event)"
      (tablesOrganized)="onTablesOrganized($event)"
      (createTable)="createNewTable()"
      (deleteTable)="deleteTable($event)">
    </app-table-grid>
  </div>

  <div class="table-config-overlay" *ngIf="showTableConfig && ((configMode === 'create' && canCreateMesas) || (configMode === 'edit' && canEditMesas))">
    <app-table-config
      [table]="selectedTable"
      [mode]="configMode"
      [selectedZoneId]="selectedZoneId"
      (saved)="onTableConfigSaved($event)"
      (cancelled)="onTableConfigCancelled()">
    </app-table-config>
  </div>

  <!-- Modal Nueva Zona -->
  <div *ngIf="canCreateMesas && showZoneForm" class="zone-form-overlay" (click)="closeZoneForm()">
    <div class="zone-form-modal" (click)="$event.stopPropagation()">
      <h3><i class="fas fa-map-marked-alt"></i> Nueva zona</h3>
      <form (ngSubmit)="saveNewZone()" class="zone-form">
        <div class="form-group">
          <label for="zoneName">Nombre</label>
          <input id="zoneName" type="text" [(ngModel)]="zoneFormName" name="zoneName" required placeholder="Ej: Terraza" />
        </div>
        <div class="form-group">
          <label for="zoneType">Tipo</label>
          <select id="zoneType" [(ngModel)]="zoneFormType" name="zoneType">
            <option value="SALA">Sala</option>
            <option value="TERRAZA">Terraza</option>
            <option value="VIP">VIP</option>
            <option value="BARRA">Barra</option>
            <option value="PISO">Piso</option>
          </select>
        </div>
        <div class="zone-form-actions">
          <button type="button" class="btn-cancel" (click)="closeZoneForm()">Cancelar</button>
          <button type="submit" class="btn-save" [disabled]="!zoneFormName.trim()">Crear zona</button>
        </div>
      </form>
    </div>
  </div>

  <!-- Modal confirmar eliminar zona -->
  <div *ngIf="canEditMesas && showDeleteZoneConfirm" class="zone-form-overlay confirm-overlay" (click)="closeDeleteZoneConfirm()">
    <div class="confirm-modal" (click)="$event.stopPropagation()">
      <h3><i class="fas fa-exclamation-triangle"></i> {{ deleteZoneHasOrders ? 'Inactivar zona' : 'Eliminar zona' }}</h3>
      <p class="confirm-message">{{ deleteZoneMessage }}</p>
      <p class="confirm-question">¿Desea continuar?</p>
      <div class="zone-form-actions confirm-actions">
        <button type="button" class="btn-cancel" (click)="closeDeleteZoneConfirm()">Cancelar</button>
        <button type="button" class="btn-confirm-delete" (click)="executeDeleteZone()">
          {{ deleteZoneHasOrders ? 'Inactivar' : 'Eliminar' }}
        </button>
      </div>
    </div>
  </div>
</div>
